import { styled } from "@mui/material/styles";

// Components
import CategoryIcon from "../CategoryIcon";
import { Typography } from "@mui/material";

const styledName = "CategoryInfo";

export const StyledIcon = styled(CategoryIcon, { name: styledName })({
  "&": {
    height: "80px",
    width: "80px",
  },
});

export const StyledName = styled(Typography, { name: styledName })({
  "&": {
    textAlign: "center",
    marginTop: "20px",
  },
});
